module.exports = __webpack_public_path__ + "fonts/c443aff893c08165b72eb1136cd4492a.svg";